import { LinearProgress, Box } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";

function TierProgress({ currentCount }) {
  const getProgress = () => {
    if (currentCount >= 100) return 100;
    if (currentCount >= 50) return ((currentCount - 50) / 50) * 100;
    return (currentCount / 50) * 100;
  };

  const getTierText = () => {
    if (currentCount >= 100) {
      return "Maximum tier reached! All new referrals earn you 40% commission";
    }
    if (currentCount >= 50) {
      return `Next referral will earn you 30% commission (${100 - currentCount} more needed for Tier 3)`;
    }
    return `Next referral will earn you 20% commission (${50 - currentCount} more needed for Tier 2)`;
  };

  const getTierLabels = () => {
    if (currentCount >= 100) {
      return { current: 'Tier 3', next: 'Max' };
    }
    if (currentCount >= 50) {
      return { current: 'Tier 2', next: 'Tier 3' };
    }
    return { current: 'Tier 1', next: 'Tier 2' };
  };

  const labels = getTierLabels();

  return (
    <Card>
      <MDBox p={2}>
        <MDTypography variant="caption" fontWeight="medium">
          {getTierText()}
        </MDTypography>

        <MDBox mt={1} mb={0.5} display="flex" justifyContent="space-between">
          <MDTypography variant="caption" fontWeight="medium">
            {labels.current}
          </MDTypography>
          <MDTypography variant="caption" fontWeight="medium">
            {labels.next}
          </MDTypography>
        </MDBox>

        <MDBox 
          sx={{ 
            width: '100%',
            height: '15px',
            backgroundColor: 'grey.300',
            borderRadius: '8px',
            overflow: 'hidden'
          }}
        >
          <Box 
            sx={{
              width: `${getProgress()}%`,
              height: '100%',
              backgroundColor: '#2196f3',
              transition: 'width 0.4s ease-in-out'
            }}
          />
        </MDBox>

        <MDTypography variant="caption" color="text" mt={1} display="block">
          {currentCount >= 100
            ? "All new referrals earn 40% commission"
            : currentCount >= 50
            ? `${100 - currentCount} more referrals until 40% commission`
            : `${50 - currentCount} more referrals until 30% commission`
          }
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default TierProgress;